import { render, staticRenderFns } from "./TabRealShipment.vue?vue&type=template&id=6b094c8a&scoped=true"
import script from "./TabRealShipment.vue?vue&type=script&lang=js"
export * from "./TabRealShipment.vue?vue&type=script&lang=js"
import style0 from "./TabRealShipment.vue?vue&type=style&index=0&id=6b094c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b094c8a",
  null
  
)

export default component.exports